import { API_COLD_CLIENTS } from "../constants/api";

export default (axios) => ({
    // Получение списка холодных клиентов
    getColdClients(params = {}) {
        return axios
            .get(API_COLD_CLIENTS, { params })
            .then(({ data }) => {
                return data;
            });
    },

    // Получение холодного клиента по ID
    getColdClient(id) {
        return axios
            .get(`${API_COLD_CLIENTS}/${id}`)
            .then(({ data }) => {
                return data;
            });
    },

    // Создание нового холодного клиента
    createColdClient(params) {
        return axios
            .post(API_COLD_CLIENTS, params)
            .then(({ data }) => {
                return data;
            });
    },

    // Обновление холодного клиента
    updateColdClient(id, params) {
        return axios
            .put(`${API_COLD_CLIENTS}/${id}`, params)
            .then(({ data }) => {
                return data;
            });
    },

    // Удаление холодного клиента
    deleteColdClient(id) {
        return axios
            .delete(`${API_COLD_CLIENTS}/${id}`)
            .then(({ data }) => {
                return data;
            });
    },

    // Получение статистики
    getStatistics() {
        return axios
            .get(`${API_COLD_CLIENTS}/statistics`)
            .then(({ data }) => {
                return data;
            });
    },

    // Получение опций статусов
    getStatusOptions() {
        return axios
            .get(`${API_COLD_CLIENTS}/status-options`)
            .then(({ data }) => {
                return data;
            });
    },

    // Назначение клиентов агенту
    assignToAgent(params) {
        return axios
            .post(`${API_COLD_CLIENTS}/assign-to-agent`, params)
            .then(({ data }) => {
                return data;
            });
    },

    // Импорт клиентов из файла
    importFromFile(formData, config = {}) {
        return axios
            .post(`${API_COLD_CLIENTS}/import`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                ...config
            })
            .then(({ data }) => {
                return data;
            });
    },
});
